<template>
	<div class="detial-wrapper">
		<el-tabs v-model="activeTabIndex">
			<el-tab-pane
				v-for="(item, index) in diagnosisData"
				:key="`tabPane-${index}`"
				:label="item.ZZMC"
				:name="String(index)"
			></el-tab-pane>
		</el-tabs>

		<!-- 诊断结果表格 -->
		<div class="diag-table">
			<table>
				<thead>
					<tr class="type-header">
						<th class="item-name" rowspan="2">类型</th>
						<th class="existing-header">现有</th>
						<th class="standard-header">标准要求</th>
						<th class="result-header">结果</th>
					</tr>
				</thead>
				<tbody>
					<!-- 动态生成行 -->
					<!-- 动态生成行 -->
					<template v-for="(rowType, rowIndex) in getUniqueTypes()">
						<tr :key="`row-${rowIndex}`">
							<!-- 不需要合并单元格 -->
							<td class="item-type br">{{ rowType.TYPE }}</td>

							<template v-for="(item, colIndex) in diagnosisData">
								<template v-if="getOptionByType(diagnosisData[activeTabIndex].RESULT, rowType.TYPE)">
									<td :key="`cell-existing-${rowIndex}-${colIndex}`" class="existing-value">
										{{ getOptionByType(diagnosisData[activeTabIndex].RESULT, rowType.TYPE).EXISTING }}
									</td>
									<td :key="`cell-standard-${rowIndex}-${colIndex}`" class="standard-value">
										{{ getOptionByType(diagnosisData[activeTabIndex].RESULT, rowType.TYPE).STANDARD_REQUIREMENTS }}
									</td>
									<td
										:key="`cell-result-${rowIndex}-${colIndex}`"
										:class="[
											'result-value',
											getOptionByType(diagnosisData[activeTabIndex].RESULT, rowType.TYPE).WHETHER ? 'success' : 'error'
										]"
									>
										{{ getOptionByType(diagnosisData[activeTabIndex].RESULT, rowType.TYPE).RESULTS }}
									</td>
								</template>
								<template v-else>
									<td :key="`cell-empty1-${rowIndex}-${colIndex}`">-</td>
									<td :key="`cell-empty2-${rowIndex}-${colIndex}`">-</td>
									<td :key="`cell-empty3-${rowIndex}-${colIndex}`">-</td>
								</template>
							</template>
						</tr>
					</template>
				</tbody>
			</table>
		</div>
	</div>
</template>

<script>
	import { getDiagnosisRecordDetail } from '@/api/certTreasure/diagnosis'

	// 房地产开发资质诊断比对结果详情
	export default {
		name: 'RealEstateDevelopmentDiagnosisResultDetail',
		components: {},
		props: {
			// 诊断记录id
			recordId: {
				type: String,
				default: ''
			}
		},
		data() {
			return {
				// 添加当前激活的tab索引
				activeTabIndex: 0,
				// 诊断结果数据
				diagnosisData: []
			}
		},
		computed: {},
		watch: {},
		created() {},
		mounted() {
			this.handleQueryRecordDetail()
		},
		methods: {
			// 查询诊断结果对比json
			handleQueryRecordDetail() {
				const params = {
					recordId: this.recordId
				}

				getDiagnosisRecordDetail(params).then(response => {
					const { data } = response

					if (data && data.diagnosisInfo) {
						// 存储报告生成状态
						this.generateState = data.generateState
						const diagnosisResultData = JSON.parse(data.diagnosisInfo)
						diagnosisResultData[0].ZZMC = '房地产开发企业资质'
						diagnosisResultData[0].ZZCODE = '111'
						console.log('diagnosisResultData:', diagnosisResultData)

						this.diagnosisData = diagnosisResultData
					}
				})
			},

			// 获取所有唯一的类型，用于生成表格行
			getUniqueTypes() {
				const types = []
				this.diagnosisData.forEach(item => {
					item.RESULT.forEach(option => {
						// types.add(option.TYPE)
						types.push({
							TYPE: option.TYPE
							// 如果需要合并单元格就打开
							// ZZMC: option.ZZMC
						})
					})
				})
				return types
			},

			// 根据类型获取对应的选项
			getOptionByType(options, type) {
				return options.find(option => option.TYPE === type)
			}
		}
	}
</script>

<style lang="scss" scoped>
	@import '../styles/diagnosisTable.scss';

	::v-deep {
		.el-tabs__header {
			margin-bottom: 20px;
			border-bottom: 1px solid #e4e7ed;
		}

		.el-tabs__nav-wrap::after {
			display: none; /* 移除默认底部线条 */
		}

		.el-tabs__item {
			padding: 10px 20px;
			// margin-right: 10px;
			font-size: 16px;
			color: #606266;
			transition: all 0.3s;
			height: auto;
			line-height: 1.5;

			&.is-active {
				color: #236fca;
				font-weight: 500;
			}

			&:hover {
				color: #236fca;
			}
		}

		.el-tabs__active-bar {
			background-color: #236fca;
			height: 2px;
		}
	}
</style>
